import React from 'react';
import { KZT_BANK_APPS, KztBankApp, KztBankPlatform } from '../../data/kztBankApps';
import { BankOptions } from './BankOptions';

interface KztBankOptionsProps {
    paymentId: string;
    transactionId: string;
    banks?: readonly KztBankApp[];
    platform?: KztBankPlatform;
    compact?: boolean;
}

export const KztBankOptions: React.FC<KztBankOptionsProps> = ({ banks = KZT_BANK_APPS, ...props }) => (
    <BankOptions
        {...props}
        banks={banks}
        qrDescription="Отсканируйте QR-код камерой телефона. В приложении банка откройте «Международные переводы». Реквизиты и сумму введите вручную."
    />
);
